//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { MessageTemplatePlaceholder } from './MessageTemplatePlaceholder';
import { EmailTemplateDisplayItem } from './EmailTemplateDisplayItem';

export class CustomEmailTemplateDisplayItem extends EmailTemplateDisplayItem {
    ID: string | null = null;
    Title: string | null = null;
    Placeholders: MessageTemplatePlaceholder[] = [];

    constructor(initializer?: Partial<CustomEmailTemplateDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomEmailTemplateDisplayItem";
}
